import { useState, useCallback, useMemo } from "react";
import { useLocation } from "react-router-dom";

/**
 * Custom hook for managing sign in form state
 */
export const useSignInForm = () => {
  const location = useLocation();

  // Check for success message from signup and prefilled email
  const successMessage = location.state?.message;
  const prefilledEmail = location.state?.email;

  // Get URL search parameters for returnUrl handling
  const searchParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search],
  );

  // Form state
  const [formData, setFormData] = useState({
    email: prefilledEmail || "",
    password: "",
  });

  const [formErrors, setFormErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [submitError, setSubmitError] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  // Handle form input changes
  const handleChange = useCallback(
    (e) => {
      const { name, value } = e.target;
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));

      // Clear errors for this field when user starts typing
      setFormErrors((prev) => {
        if (prev[name]) {
          return { ...prev, [name]: "" };
        }
        return prev;
      });

      // Clear submit error
      if (submitError) {
        setSubmitError("");
      }
    },
    [submitError],
  );

  // Toggle password visibility
  const toggleShowPassword = useCallback(() => {
    setShowPassword((prev) => !prev);
  }, []);

  return {
    formData,
    formErrors,
    setFormErrors,
    isLoading,
    setIsLoading,
    submitError,
    setSubmitError,
    showPassword,
    successMessage,
    searchParams,
    handleChange,
    toggleShowPassword,
  };
};
